import axios from "axios";

const URL_LOCALHOST = "http://localhost:3500";
const URL_WEB = "https://backend.viajesarequipa.com/";

export const baseTour = axios.create({
  baseURL: URL_WEB,
});
